<script setup lang="ts">
// types
import type { BlockGradeTypeCardProps } from '@ts-blocks/block-grade-type-card/interfaces'
import type { GradeTypeColor } from '@hooks/sections/section-grade-type.hook'

defineOptions({
  name: 'BlockGradeTypeCard',
})

withDefaults(defineProps<{
  block: BlockGradeTypeCardProps
  color?: GradeTypeColor
  isOpen?: boolean
}>(), {
  color: 'sunshine',
  isOpen: true,
})
</script>

<template>
  <article
    class="block-grade-type-card"
    :class="[
      `block-grade-type-card--${color}`,
      { 'block-grade-type-card--open': isOpen },
    ]"
  >
    <h3 class="block-grade-type-card__title btly-text-title-xl lg:btly-text-heading-s">
      <span class="block-grade-type-card__title-lead">{{ block.titleLead }}</span>
      <span>{{ block.title }}</span>
    </h3>
    <div class="block-grade-type-card__description-wrap">
      <p class="block-grade-type-card__description btly-text-body-l">{{ block.description }}</p>
    </div>
  </article>
</template>

<style scoped lang="scss" src="@scss/components/Blocks/BlockGradeTypeCard.scss" />
